export const PRODUCT_ATTRIBUTES_TAB = 'productAttributes';
export const VARIANT_ATTRIBUTES_TAB = 'variantAttributes';

export const GROUP_TITLES_BY_SCOPE = {
  product: 'Custom product attributes',
  variant: 'Custom variant attributes',
};

export function getScopeFromTab(tabId) {
  if (tabId === VARIANT_ATTRIBUTES_TAB) return 'variant';
  if (tabId === PRODUCT_ATTRIBUTES_TAB) return 'product';
  return null;
}

export function getScopeFromHash(hash = '') {
  return getScopeFromTab(hash.replace(/^#/, ''));
}

export function getProductAttributeHash(scope) {
  if (scope === 'variant') return `#${VARIANT_ATTRIBUTES_TAB}`;
  if (scope === 'product') return `#${PRODUCT_ATTRIBUTES_TAB}`;
  return '';
}

export function filterItemsByScope(items = [], scope) {
  if (!scope) return items;
  return items.filter((item) => item.scope === scope);
}

export function matchesProductAttribute(item, { title, scope }) {
  return item.title === title && item.scope === scope;
}

export function sortProductAttributes(items = []) {
  return [...items].sort((left, right) => {
    if (left.scope === right.scope) {
      return (left.order || 0) - (right.order || 0);
    }

    if (left.scope === 'product') return -1;
    if (right.scope === 'product') return 1;
    return String(left.scope).localeCompare(String(right.scope));
  });
}
